import { IonButton, IonItem, IonLabel } from '@ionic/react';
import moment from 'moment';

export const JobRow = ({color, job, history}) => (
  <IonItem button={true} color={color} onClick={(e) => {
      e.stopPropagation();
      history.push(`/job/${job.id}`);
    }} detail
    lines='none'
  >
    <IonLabel>
      <h3>
        <strong>
          {job.booking
            ? `${job.booking.id} - ${job.property.name} - ${job?.booking?.guesttype}`
            : `${job.id} - ${job.property.name} - No booking`}
        </strong>
      </h3>
      <h3 className='job-secondary'>
        {job.requiredbydate || job.preferredstartdatetime ? (moment(job.preferredstartdatetime || job.requiredbydate).format('ddd Do MMM YYYY')) : 'No date'} - {' '}
        {job.fulldescription || job.shortdescription}
      </h3>
    </IonLabel>

    <IonButton
      fill='clear'
      size='small'
      onClick={(e) => {
        e.stopPropagation();
        history.push(`/job/${job.id}`);
      }}
    >
    </IonButton>
  </IonItem>
);
